/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Reads_Min_ReadInputs */

const en_reads_min_read = /** @type {(inputs: Reads_Min_ReadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} min read`)
};

const ar_reads_min_read = /** @type {(inputs: Reads_Min_ReadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} دقائق قراءة`)
};

const bn_reads_min_read = /** @type {(inputs: Reads_Min_ReadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`পড়তে ${i?.count} মিনিট`)
};

const de_reads_min_read = /** @type {(inputs: Reads_Min_ReadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Min. Lesezeit`)
};

const es_reads_min_read = /** @type {(inputs: Reads_Min_ReadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} lectura mínima`)
};

const fr_reads_min_read = /** @type {(inputs: Reads_Min_ReadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} minutes de lecture`)
};

const pt_reads_min_read = /** @type {(inputs: Reads_Min_ReadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} minutos de leitura`)
};

const zh_reads_min_read = /** @type {(inputs: Reads_Min_ReadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 分钟阅读次数`)
};

const tr_reads_min_read = /** @type {(inputs: Reads_Min_ReadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} dakika okuma`)
};

const ru_reads_min_read = /** @type {(inputs: Reads_Min_ReadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} мин чтения`)
};

const pl_reads_min_read = /** @type {(inputs: Reads_Min_ReadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} min przeczytania`)
};

/**
* | output |
* | --- |
* | "{count} min read" |
*
* @param {Reads_Min_ReadInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const reads_min_read = /** @type {((inputs: Reads_Min_ReadInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reads_Min_ReadInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_reads_min_read(inputs)
	if (locale === "bn") return bn_reads_min_read(inputs)
	if (locale === "de") return de_reads_min_read(inputs)
	if (locale === "es") return es_reads_min_read(inputs)
	if (locale === "fr") return fr_reads_min_read(inputs)
	if (locale === "pt") return pt_reads_min_read(inputs)
	if (locale === "zh") return zh_reads_min_read(inputs)
	if (locale === "tr") return tr_reads_min_read(inputs)
	if (locale === "ru") return ru_reads_min_read(inputs)
	if (locale === "pl") return pl_reads_min_read(inputs)
	return en_reads_min_read(inputs)
});